module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Black ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "CharOverride-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Resilient")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("52 Weeks of Anti-Racist Activities for Black Joy"), _c('br'), _vm._v("and Empowerment")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("M.J. Fievre")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Mango_Publishing_Group.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Coral Gables")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b02eb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlackAndResilient1.vue
// module id = 63
// module chunks = 0